import type { SimpleFieldConfig } from "../../../UniversalCRMTable/types";

export interface ToggleOption {
  value: string;
  label: string;
}

/** Returns true for boolean fields and select fields with 2–3 options. */
export function isInlineToggleField(fieldConfig: SimpleFieldConfig): boolean {
  if (fieldConfig.type === "boolean") return true;
  if (fieldConfig.type === "select" && fieldConfig.options && fieldConfig.options.length <= 3) {
    return true;
  }
  return false;
}

export function getToggleOptions(fieldConfig: SimpleFieldConfig): ToggleOption[] {
  if (fieldConfig.type === "boolean") {
    return [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ];
  }
  if (fieldConfig.type === "select" && fieldConfig.options) {
    return fieldConfig.options.map((opt) => ({ value: String(opt.value), label: opt.label }));
  }
  return [];
}

export function getCurrentToggleValue(value: unknown, fieldConfig: SimpleFieldConfig): string {
  if (fieldConfig.type === "boolean") {
    if (value === true || value === "true") return "true";
    return "false";
  }
  return String(value ?? "");
}

export function getCopyableValue(value: unknown): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (value instanceof Date) return value.toISOString();

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
